module.exports = am4themes_animated;